import rereshSecureRequest from "./requests/refresh-secure-request";
import loginRequest from "./requests/login-request";
import registerRequest from "./requests/register-request";
import sendConfirmRequest from "./requests/send-confirm-request";
import confirmMailRequest from "./requests/confirm-mail-request";
import forgetSendRequest from "./requests/forget-send-request";
import forgetActionRequest from "./requests/forget-action-request";

const authRepository = {
    refreshSecure: rereshSecureRequest,
    login: loginRequest,
    register: registerRequest,
    sendConfirm: sendConfirmRequest,
    confirmMail: confirmMailRequest,
    forgetSend: forgetSendRequest,
    forgetAction: forgetActionRequest,
};

export default authRepository;